/* Utility js functions */

// Check CSS Sticky is active
export function axCheckSticky( element, cssClassDynamic ) {
	const el = document.querySelector( element );

	if ( el ) {
		el.style.top = '-1px';

		const observer = new IntersectionObserver(
			( [ e ] ) =>
				e.target.classList.toggle(
					cssClassDynamic,
					e.intersectionRatio < 1
				),
			{ threshold: [ 1 ] }
		);

		observer.observe( el );
	}
}

// Text Rotate
export function axRotateText(containerSelector, itemSelector, interval = 3000) {
    const textContainers = document.querySelectorAll(containerSelector);
    
    // Check if any text containers exist in the DOM
    if (textContainers.length === 0) return;

    // Loop through each text container and apply rotation logic
    textContainers.forEach((textContainer) => {
      const items = textContainer.querySelectorAll(itemSelector);
      let currentIndex = 0;

      // Ensure there are items to rotate
      if (items.length === 0) return;

      setInterval(() => {
        // Remove 'active' class from the current item
        items[currentIndex].classList.remove('active');

        // Move to the next item, looping back to the start if necessary
        currentIndex = (currentIndex + 1) % items.length;

        // Add 'active' class to the next item
        items[currentIndex].classList.add('active');
      }, interval);
    });
}

// Job Application Slide
export function axJobApplicationAnimations(
  triggerSelector = '.js-trigger-application-form', 
  panelSelector = '.js-application-form', 
  closeSelector = '.js-close-application-form'
) {
  const triggerLinks = document.querySelectorAll(triggerSelector);
  const closeButtons = document.querySelectorAll(closeSelector);
  const body = document.body; // Reference to the body element

  if (triggerLinks.length === 0 && closeButtons.length === 0) return; // Exit if no trigger or close elements found

  triggerLinks.forEach(trigger => {
    const panel = document.querySelector(panelSelector); // Select the panel directly
    if (!panel) return; // Exit if no valid panel found

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      panel.classList.add('is-job-panel-open');
      body.classList.add('js-job-panel-open');
      
      // Use setTimeout to add the animation class
      setTimeout(() => {
        panel.classList.add('animate'); // Add animation class after delay
      }, 100); // Default delay
    });
  });

  closeButtons.forEach(button => {
    const panel = document.querySelector(panelSelector); // Select the panel directly
    if (!panel) return; // Exit if no valid panel found

    button.addEventListener('click', function (event) {
      event.preventDefault();
      panel.classList.remove('is-job-panel-open');
      body.classList.remove('js-job-panel-open');
      
      // Use setTimeout to add the animation class on close
      setTimeout(() => {
        panel.classList.remove('animate'); // Remove animation class after delay
      }, 100); // Default delay
    });
  });
}

